/*eslint import/namespace: ['error', { allowComputed: true }]*/
import _ from "lodash";
import update from "immutability-helper";
// eslint-disable-next-line disable-autofix/import/no-namespace
import * as ENTITY_FLOW_MODULE_FUNCS from "./EntityFlow/Module";
// eslint-disable-next-line disable-autofix/import/no-namespace
import * as LEARNING_COURSE_MODULE_FUNCS from "./LearningCourseFlow/Module";
import { getIsLearningCoursesEnabledForUnit } from "UnitPlans/modules/UnitViewModeUtils";

// Common module state names
const NAME = "CombinedLibrary";
const SET_ASSESSMENT_IMPORT_MODAL_DATA = `SET_ASSESSMENT_IMPORT_MODAL_DATA_${NAME}`;
const SET_ADD_NOTE_MODAL_DATA = `SET_ADD_NOTE_MODAL_DATA_${NAME}`;
const SET_WORKSHEET_MODAL_DATA = `SET_WORKSHEET_MODAL_DATA_${NAME}`;
const SET_ADD_LINK_MODAL_DATA = `SET_ADD_LINK_MODAL_DATA_${NAME}`;
const SET_ACTIVE_CONTENT_DATA = `SET_ACTIVE_CONTENT_DATA_${NAME}`;
const SET_ACTION_LOADING = `SET_ACTION_LOADING_${NAME}`;

// Initial state for redux
const initialState = {
  assessmentImportModalData: {},
  addNoteModalData: {},
  worksheetModalData: {},
  addLinkModalData: {},
  activeContentData: {},
  isActionLoading: false,
};

// Action creators
export const setAssessmentImportModalData = data => ({
  type: SET_ASSESSMENT_IMPORT_MODAL_DATA,
  data,
});

export const setAddNoteModalData = data => ({
  type: SET_ADD_NOTE_MODAL_DATA,
  data,
});

export const setWorksheetModalData = data => ({
  type: SET_WORKSHEET_MODAL_DATA,
  data,
});

export const setAddLinkModalData = data => ({
  type: SET_ADD_LINK_MODAL_DATA,
  data,
});

export const setActiveContentData = data => ({
  type: SET_ACTIVE_CONTENT_DATA,
  data,
});

export const setIsCombinedLibraryActionLoading = data => ({
  type: SET_ACTION_LOADING,
  data,
});

// Common reducer handlers
const REDUCER_HANDLERS = {
  [SET_ASSESSMENT_IMPORT_MODAL_DATA]: (state, action) => {
    return update(state, { assessmentImportModalData: { $set: action.data } });
  },
  [SET_ADD_NOTE_MODAL_DATA]: (state, action) => {
    return update(state, { addNoteModalData: { $set: action.data } });
  },
  [SET_WORKSHEET_MODAL_DATA]: (state, action) => {
    return update(state, { worksheetModalData: { $set: action.data } });
  },
  [SET_ADD_LINK_MODAL_DATA]: (state, action) => {
    return update(state, { addLinkModalData: { $set: action.data } });
  },
  [SET_ACTIVE_CONTENT_DATA]: (state, action) => {
    return update(state, { activeContentData: { $set: action.data } });
  },

  [SET_ACTION_LOADING]: (state, action) => {
    return update(state, { isActionLoading: { $set: action.data } });
  },
};

const combinedLibraryReducer = (state = initialState, action) => {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

// Function to get all common module actions and entity-specific actions
export const getCombinedLibraryModuleFuncs = () => {
  const learningCourseModuleFuncs = _.keys(LEARNING_COURSE_MODULE_FUNCS);
  const entityFlowModuleFuncs = _.keys(ENTITY_FLOW_MODULE_FUNCS);

  const moduleSet = new Set([
    ...learningCourseModuleFuncs,
    ...entityFlowModuleFuncs,
  ]);

  const moduleFuncs = {};
  [...moduleSet].forEach(funcName => {
    moduleFuncs[funcName] = args => {
      const isLearningCoursesEnabled = getIsLearningCoursesEnabledForUnit();
      return isLearningCoursesEnabled
        ? LEARNING_COURSE_MODULE_FUNCS[funcName]?.(args)
        : ENTITY_FLOW_MODULE_FUNCS[funcName]?.(args);
    };
  });

  // Return both common and entity-specific functions
  return {
    // Common module actions
    setAssessmentImportModalData,
    setAddNoteModalData,
    setAddLinkModalData,
    setWorksheetModalData,
    setActiveContentData,
    setIsCombinedLibraryActionLoading,
    // Entity-specific actions
    ...moduleFuncs,
  };
};
export default combinedLibraryReducer;
